module.exports = __webpack_public_path__ + "static/taskit-964d92ca876d702dad113c2c25569c95.png";